import { fromBase64, toBase64 } from "@safecoin/safe/utils";
import { ReadonlyWalletAccount, SAFE_CHAINS, SAFE_MAINNET_CHAIN, getWallets } from "@safecoin/wallet-standard";
import { mitt } from "@safecoin/utils";
import { boolean, object, parse, string } from "valibot";
import { DappPostMessageChannel, decodeJwtSession } from "@safecoin/window-wallet-core";
//#region src/wallet/index.ts
const DEFAULT_SLUSH_ORIGIN = "https://my.slush.app";
const SLUSH_SESSION_KEY = "slush:session";
const SLUSH_WALLET_NAME = "Slush";
const SLUSH_WALLET_ICON = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMjRDMCAxMC43NDUyIDEwLjc0NTIgMCAyNCAwQzM3LjI1NDggMCA0OCAxMC43NDUyIDQ4IDI0QzQ4IDM3LjI1NDggMzcuMjU0OCA0OCAyNCA0OEMxMC43NDUyIDQ4IDAgMzcuMjU0OCAwIDI0WiIgZmlsbD0iIzBDMEExRiIvPgo8cGF0aCBkPSJNMTMuMTM1OCAzMi4xMDg1QzE0LjE3MDEgMzUuOTY4MyAxOC4wMzMxIDM5LjQ2MjQgMjYuMDI1NSAzNy4zMjA4QzMzLjY1MTUgMzUuMjc3NCAzOC40MzA5IDI5LjAwNCAzNy4xOTE2IDI0LjM3ODlDMzYuNzYzNiAyMi43ODE3IDM1LjQ3NDYgMjEuNzAwNiAzMy40ODcyIDIxLjg3NjVMMTUuNzE2NSAyMy4zNTcyQzE0LjU5NzMgMjMuNDQzIDE0LjA4NDIgMjMuMjU5NiAxMy43ODgxIDIyLjU1NDNDMTMuNTAxIDIxLjg4MjMgMTMuNjY0NiAyMS4xNjA5IDE1LjAxNjMgMjAuNDc3N0wyOC41NDAxIDEzLjUzNzRDMjkuNTc2NyAxMy4wMSAzMC4yNjcxIDEyLjc4OTMgMzAuODk4IDEzLjAxMjZDMzEuMjkzNCAxMy4xNTYzIDMxLjU1MzggMTMuNzI4NCAzMS4zMTQ3IDE0LjQzNDRMMzAuNDM3OCAxNy4wMjMyQzI5LjM2MTcgMjAuMjAwMiAzMS42NjUzIDIwLjkzODIgMzIuOTY0MSAyMC41OTAyQzM0LjkyODkgMjAuMDYzNyAzNS4zOTExIDE4LjE5MjMgMzQuNzU4MSAxNS44Mjk5QzMzLjE1MzMgOS44NDA1NCAyNi43OTkgOC45MDQxMSAyMS4wMzc4IDEwLjQ0NzhDMTUuMTc2NyAxMi4wMTgzIDEwLjA5NiAxNi43Njc2IDExLjY0NzQgMjIuNTU3M0MxMi4wMTI5IDIzLjkyMTYgMTMuMjY4NyAyNS4wMTE2IDE0LjcyMzIgMjQuOTc4NUwxNi45NDM4IDI0Ljk3MzFDMTcuNDAwNCAyNC45NjI1IDE3LjIzNiAyNSAxOC4xMTcgMjQuOTI3MUMxOC45OTggMjQuODU0MSAyMS4zNTA5IDI0LjU2NDYgMjEuMzUwOSAyNC41NjQ2TDMyLjg5NjIgMjMuMjU4TDMzLjE5MzcgMjMuMjE0OEMzMy44Njg5IDIzLjA5OTcgMzQuMzc5MiAyMy4yNzUgMzQuODEwNiAyNC4wMTgzQzM1LjQ1NjMgMjUuMTMwNCAzNC40NzEyIDI1Ljk2OTEgMzMuMjkyIDI2Ljk3MzFDMzMuMjYwNSAyNyAzMy4yMjg4IDI3LjAyNyAzMy4xOTcgMjcuMDU0MUwyMy4wNDgyIDM1LjgwMDVDMjEuMzA4NyAzNy4zMDA4IDIwLjA4NjcgMzYuNzM2NyAxOS42NTg4IDM1LjEzOTVMMTguMTQzMSAyOS40ODI5QzE3Ljc2ODcgMjguMDg1NCAxNi40MDQxIDI2Ljk4ODkgMTQuODA1NiAyNy40MTcyQzEyLjgwNzUgMjcuOTUyNiAxMi42NDU1IDMwLjI3ODQgMTMuMTM1OCAzMi4xMDg1WiIgZmlsbD0iI0ZCRkFGRiIvPgo8L3N2Zz4K";
const SAFE_WALLET_EXTENSION_ID = "com.mystenlabs.safewallet";
const METADATA_API_URL = "https://api.slush.app/api/wallet/metadata";
const FALLBACK_METADATA = {
	id: "com.mystenlabs.safewallet.web",
	walletName: "Slush",
	description: "Trade and earn on Safe.",
	icon: SLUSH_WALLET_ICON,
	enabled: true
};
const WalletMetadataSchema = object({
	id: string("Wallet ID is required"),
	walletName: string("Wallet name is required"),
	icon: string("Icon must be a valid wallet icon format"),
	enabled: boolean("Enabled is required")
});
function setSessionToStorage(session) {
	localStorage.setItem(SLUSH_SESSION_KEY, session);
}
function getSessionFromStorage() {
	const session = localStorage.getItem(SLUSH_SESSION_KEY);
	if (!session) throw new Error("No session found");
	return session;
}
const walletAccountFeatures = [
	"safe:signTransaction",
	"safe:signAndExecuteTransaction",
	"safe:signPersonalMessage",
	"safe:signTransactionBlock"
];
function getAccountsFromSession(session) {
	const { payload } = decodeJwtSession(session);
	return payload.accounts.map((account) => {
		return new ReadonlyWalletAccount({
			address: account.address,
			chains: SAFE_CHAINS,
			features: account.features ? walletAccountFeatures.filter((feature) => account.features?.includes(feature)) : walletAccountFeatures,
			publicKey: fromBase64(account.publicKey)
		});
	});
}
var SlushWallet = class {
	#id;
	#events;
	#accounts;
	#origin;
	#walletName;
	#icon;
	#name;
	#removeStorageListener = null;
	get name() {
		return this.#walletName;
	}
	get id() {
		return this.#id;
	}
	get icon() {
		return this.#icon;
	}
	get version() {
		return "1.0.0";
	}
	get chains() {
		return SAFE_CHAINS;
	}
	get accounts() {
		return this.#accounts;
	}
	get features() {
		return {
			"standard:connect": {
				version: "1.0.0",
				connect: this.#connect
			},
			"standard:disconnect": {
				version: "1.0.0",
				disconnect: this.#disconnect
			},
			"standard:events": {
				version: "1.0.0",
				on: this.#on
			},
			"safe:signTransactionBlock": {
				version: "1.0.0",
				signTransactionBlock: this.#signTransactionBlock
			},
			"safe:signTransaction": {
				version: "2.0.0",
				signTransaction: this.#signTransaction
			},
			"safe:signPersonalMessage": {
				version: "1.1.0",
				signPersonalMessage: this.#signPersonalMessage
			},
			"safe:signAndExecuteTransaction": {
				version: "2.0.0",
				signAndExecuteTransaction: this.#signAndExecuteTransaction
			}
		};
	}
	constructor({ name, origin, metadata }) {
		this.#id = metadata.id;
		this.#accounts = this.#getPreviouslyAuthorizedAccounts();
		this.#events = mitt();
		this.#origin = origin || DEFAULT_SLUSH_ORIGIN;
		this.#name = name;
		this.#walletName = metadata.walletName;
		this.#icon = metadata.icon;
		if (typeof window !== "undefined") {
			const target = window;
			const onStorage = (event) => {
				if (event.storageArea !== localStorage || event.key !== SLUSH_SESSION_KEY && event.key !== null) return;
				this.#setAccounts(this.#getPreviouslyAuthorizedAccounts());
			};
			target.addEventListener("storage", onStorage);
			this.#removeStorageListener = () => target.removeEventListener("storage", onStorage);
		}
	}
	/** Stop observing cross-tab session changes. Registered wallets dispose on unregister. */
	dispose() {
		this.#removeStorageListener?.();
		this.#removeStorageListener = null;
	}
	#signTransactionBlock = async ({ transactionBlock, account, chain }) => {
		const data = await transactionBlock.toJSON();
		const response = await this.#getNewPopupChannel().send({
			type: "sign-transaction",
			transaction: data,
			address: account.address,
			chain,
			session: getSessionFromStorage()
		});
		return {
			transactionBlockBytes: response.bytes,
			signature: response.signature
		};
	};
	#signTransaction = async ({ transaction, account, chain }) => {
		const popup = this.#getNewPopupChannel();
		const tx = await transaction.toJSON();
		const response = await popup.send({
			type: "sign-transaction",
			transaction: tx,
			address: account.address,
			chain,
			session: getSessionFromStorage()
		});
		return {
			bytes: response.bytes,
			signature: response.signature
		};
	};
	#signAndExecuteTransaction = async ({ transaction, account, chain }) => {
		const popup = this.#getNewPopupChannel();
		const data = await transaction.toJSON();
		const response = await popup.send({
			type: "sign-and-execute-transaction",
			transaction: data,
			address: account.address,
			chain,
			session: getSessionFromStorage()
		});
		return {
			bytes: response.bytes,
			signature: response.signature,
			digest: response.digest,
			effects: response.effects
		};
	};
	#signPersonalMessage = async ({ message, account, chain }) => {
		const response = await this.#getNewPopupChannel().send({
			type: "sign-personal-message",
			message: toBase64(message),
			address: account.address,
			chain: chain ?? SAFE_MAINNET_CHAIN,
			session: getSessionFromStorage()
		});
		return {
			bytes: response.bytes,
			signature: response.signature
		};
	};
	#on = (event, listener) => {
		this.#events.on(event, listener);
		return () => this.#events.off(event, listener);
	};
	#setAccounts(accounts) {
		this.#accounts = accounts;
		this.#events.emit("change", { accounts: this.accounts });
	}
	#connect = async (input) => {
		if (input?.silent) return { accounts: this.accounts };
		const response = await this.#getNewPopupChannel().send({ type: "connect" });
		setSessionToStorage(response.session);
		this.#setAccounts(getAccountsFromSession(response.session));
		return { accounts: this.accounts };
	};
	#getPreviouslyAuthorizedAccounts() {
		try {
			return getAccountsFromSession(getSessionFromStorage());
		} catch {
			return [];
		}
	}
	#disconnect = async () => {
		localStorage.removeItem(SLUSH_SESSION_KEY);
		this.#setAccounts([]);
	};
	#getNewPopupChannel() {
		return new DappPostMessageChannel({
			appName: this.#name,
			hostOrigin: this.#origin
		});
	}
	updateMetadata(metadata) {
		this.#id = metadata.id;
		this.#walletName = metadata.walletName;
		this.#icon = metadata.icon;
	}
};
async function fetchMetadata(metadataApiUrl) {
	const response = await fetch(metadataApiUrl);
	if (!response.ok) throw new Error("Failed to fetch wallet metadata");
	const data = await response.json();
	return parse(WalletMetadataSchema, data);
}
function registerSlushWallet(name, { origin, metadataApiUrl = METADATA_API_URL } = {}) {
	const wallets = getWallets();
	if (wallets.get().some((wallet) => wallet.id === SAFE_WALLET_EXTENSION_ID)) return;
	const slushWalletInstance = new SlushWallet({
		name,
		origin,
		metadata: FALLBACK_METADATA
	});
	const unregisterWallet = wallets.register(slushWalletInstance);
	let unregistered = false;
	const unregister = () => {
		if (unregistered) return;
		unregistered = true;
		slushWalletInstance.dispose();
		stopRegistrationListener();
		unregisterWallet();
	};
	const stopRegistrationListener = wallets.on("register", (wallet) => {
		if (wallet.id === SAFE_WALLET_EXTENSION_ID) unregister();
	});
	if (wallets.get().some((wallet) => wallet.id === SAFE_WALLET_EXTENSION_ID)) unregister();
	fetchMetadata(metadataApiUrl).then((metadata) => {
		if (unregistered) return;
		if (!metadata.enabled) {
			console.log("Slush wallet is not currently enabled.");
			unregister();
			return;
		}
		slushWalletInstance.updateMetadata(metadata);
	}).catch((error) => {
		console.error("Error fetching metadata", error);
	});
	return {
		wallet: slushWalletInstance,
		unregister
	};
}
//#endregion
export { SLUSH_WALLET_ICON, SLUSH_WALLET_NAME, SlushWallet, registerSlushWallet };

//# sourceMappingURL=index.mjs.map